import { useAuth } from 'hooks/auth';
import { api } from 'services';

export function useUploadFile() {
  const { token } = useAuth();

  const uploadFile = async (ids: string[], file: File) => {
    const formData = new FormData();
    formData.append('ids', JSON.stringify(ids));
    formData.append('file', file);

    const response = await api.post(
      `/stocks/upload-nfe`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': `Bearer ${token}`,
        },
      }
    );

    return response.data;
  };

  return { uploadFile };
}
